import { adminRoutes } from '@bettermode/domain/routes/web/admin'
import { Alert } from '@tribeplatform/react-ui-kit/Alert'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { T } from '../../../i18n/components/T.js'
import { Link } from '../../../Link/Link.js'

interface Props {
  isPrivateNetwork: boolean
  isPrivateSpace: boolean
  isNetworkNoIndex: boolean
  isSpaceNoindex: boolean
}
export const SitemapWarnings = ({
  isPrivateNetwork,
  isPrivateSpace,
  isNetworkNoIndex,
  isSpaceNoindex,
}: Props) => {
  if (isPrivateNetwork) {
    return (
      <Alert status="info">
        <T
          defaultMessage="Your site is private. Therefore, the sitemap cannot be generated. <link>Site settings</link>"
          id="Admin.SeoSettings.Sitemap.PrivateNetworkWarning"
          values={{
            link: chunks => {
              return (
                <Link
                  href={adminRoutes.settings.network.root}
                  variant="accent"
                  target="_blank"
                  className="inline-block"
                >
                  <SvgIcon name="cog" className="ms-1" inline />
                  {chunks}
                </Link>
              )
            },
          }}
        />
      </Alert>
    )
  }

  if (isNetworkNoIndex) {
    return (
      <Alert status="info">
        <T
          defaultMessage="You have hidden your site from search engines. Therefore, the sitemap cannot be generated. <link>SEO settings</link>"
          id="Admin.SeoSettings.Sitemap.HiddenSiteWarning"
          values={{
            link: chunks => {
              return (
                <Link
                  href={adminRoutes.settings.seo.root}
                  variant="accent"
                  target="_blank"
                  className="inline-block"
                >
                  <SvgIcon name="cog" className="ms-1" inline />
                  {chunks}
                </Link>
              )
            },
          }}
        />
      </Alert>
    )
  }

  if (isPrivateSpace) {
    return (
      <Alert status="info">
        <T
          defaultMessage="Your space is private. Therefore, the sitemap cannot be generated."
          id="Admin.SeoSettings.Sitemap.PrivateSpaceWarning"
        />
      </Alert>
    )
  }

  if (isSpaceNoindex) {
    return (
      <Alert status="info">
        <T
          defaultMessage="You have hidden your space from search engines. Therefore, the sitemap cannot be generated."
          id="Admin.SeoSettings.Sitemap.HiddenSpaceWarning"
        />
      </Alert>
    )
  }

  return null
}
